import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

// Serif "T" text-styles glyph. Vector from Figma V6 Message toolbar
// (node 9739:22167, "Text"), same glyph as the Gripp OS MessageComposer.
export const TextIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 17.5 17.5"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M8.75 0.75H0.75V2.75M8.75 0.75H16.75V2.75M8.75 0.75V16.75M6.25 16.75H11.25"
      stroke={color}
      strokeWidth="1.5"
    />
  </Svg>
);

TextIcon.displayName = 'TextIcon';
